import { showToast } from '../../utils/toast.js';
import { syncRichPromptEditorDisabledState } from '../richPromptEditor.js';

export function resolveForm(formOrId) {
  if (!formOrId) return null;
  if (formOrId instanceof Element) return formOrId;
  return document.getElementById(String(formOrId)) ?? null;
}

export function validateRequiredFields(formOrId, requiredFields, { showErrors = true } = {}) {
  const form = resolveForm(formOrId);
  if (!form) return { valid: false, errors: ['Form not found'] };

  const errors = [];
  for (const field of requiredFields) {
    const el = form.querySelector(`#${field}`) ?? form.querySelector(`[name="${field}"]`);
    if (!el?.value?.trim()) {
      const label = field.replace(/-/g, ' ');
      errors.push(label);
      if (showErrors) showToast(`Fill ${label}`, 'exclamation-triangle');
    }
  }
  return { valid: errors.length === 0, errors };
}

export function addOptionIfNotExist(select, value, text, { selectValue = false } = {}) {
  if (!select || value === undefined) return;
  if (!Array.from(select.options).some((opt) => opt.value == value)) {
    const option = document.createElement('option');
    option.value = value;
    option.textContent = text || value;
    select.appendChild(option);
  }
  if (selectValue) select.value = value;
}

const FORM_CONTROL_SEL = 'input, textarea, select, button';

const setControlsLocked = (elements, lock) => {
  elements.forEach((el) => {
    if (lock) {
      if (!el.dataset.originalDisabled) {
        el.dataset.originalDisabled = String(!!el.disabled);
      }
      el.disabled = true;
      return;
    }
    el.disabled = el.dataset.originalDisabled === 'true';
    delete el.dataset.originalDisabled;
  });
};

const syncRecruitPanelRichEditors = (root) => {
  if (!root) return;
  root.querySelectorAll('.recruit-panel textarea').forEach((textarea) => {
    syncRichPromptEditorDisabledState(textarea);
  });
};

export function lockFormControls(formId, extraSelectors = []) {
  const form = document.getElementById(formId);
  if (!form) return;
  setControlsLocked(form.querySelectorAll(FORM_CONTROL_SEL), true);
  if (extraSelectors.length) {
    setControlsLocked(document.querySelectorAll(extraSelectors.join(',')), true);
  }
  syncRecruitPanelRichEditors(form);
}

export function unlockFormControls(formId, extraSelectors = []) {
  const form = document.getElementById(formId);
  if (!form) return;
  setControlsLocked(form.querySelectorAll(FORM_CONTROL_SEL), false);
  if (extraSelectors.length) {
    setControlsLocked(document.querySelectorAll(extraSelectors.join(',')), false);
  }
  syncRecruitPanelRichEditors(form);
}
